import React, { useLayoutEffect, useRef, useState } from 'react';
import { rgb2Hex } from '../../../../utils/javascript';
import { ChartColorPickerContainer, ChartColorPickerContent } from './styles';
import ColorPicker from '../../../../artboard/ColorPicker';
import { Button, Icon, Popover, Tooltip } from 'antd';

export const ChartColorPicker = ({ fontColor, onColorChange, removeColorPalette, index, deleteColorPicker }) => {
  const [showPicker, setShowPicker] = useState(false);
  const [showPrimaryPopover, setShowPrimaryPopover] = useState(false);
  const colorPickerContainerRef = useRef(null);

  useLayoutEffect(() => {
    if (!showPicker || !colorPickerContainerRef.current) return;
    const rect = colorPickerContainerRef.current.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    if (rect.bottom > viewportHeight) {
      colorPickerContainerRef.current.style.transform = 'translate(0px, -390px)';
    }
  }, [showPicker]);

  return (
    <Popover
      content={<Tooltip
        title={'Delete'}
        placement="top"
      >
        <Button onClick={() => {
          removeColorPalette(index);
          setShowPrimaryPopover(false)
        }}>
          <Icon type="delete" />          
        </Button>
      </Tooltip>}
      trigger="hover"
      overlayClassName="chart-hor-popover"
      visible={showPrimaryPopover}
      onVisibleChange={vis => {
        deleteColorPicker &&  setShowPrimaryPopover(vis);        
      }}
    >
      <ChartColorPickerContainer
        style={{
          backgroundColor: rgb2Hex(fontColor),
        }}
        onClick={() => setShowPicker(true)} 
      >
        {showPicker && (
          <ChartColorPickerContent ref={colorPickerContainerRef} style={{height: '366px'}}>
            <ColorPicker
              onChange={color => onColorChange(color, fontColor)}
              onBlur={() => setShowPicker(false)}
              color={rgb2Hex(fontColor)}
              qlEditor={true}
            />
          </ChartColorPickerContent>
        )}
      </ChartColorPickerContainer>
    </Popover>
  );
};
